var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRegFullPageR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 80,
    viewBox: "0 0 140 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5154_54779)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 0.0195312H6.51163C2.91535 0.0195312 0 2.67266 0 5.94546V74.0936C0 77.3664 2.91535 80.0195 6.51163 80.0195H133.488C137.085 80.0195 140 77.3664 140 74.0936V5.94546C140 2.67266 137.085 0.0195312 133.488 0.0195312Z",
    fill: "#4F4C57"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5154_54779",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 128,
    height: 70
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 5.94531H6.51172V74.0935H133.488V5.94531Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5154_54779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.488 5.94531H6.51172V74.0935H133.488V5.94531Z",
    fill: "#4F4C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4187 5.94531H6.51172V43.7231H94.4187V5.94531Z",
    fill: "#625E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6149 38.7841H23.4499C24.4437 38.7841 24.9611 38.3106 24.9611 37.4059V32.261C24.9611 31.3563 24.4437 30.8828 23.4499 30.8828H15.6149C14.6258 30.8828 14.1084 31.3521 14.1084 32.261V37.4059C14.1084 38.3106 14.6258 38.7841 15.6149 38.7841ZM17.6893 34.9116C17.0619 34.9116 16.5445 34.4381 16.5445 33.859C16.5445 33.2841 17.0619 32.8021 17.6893 32.8021C18.3121 32.8021 18.8249 33.2841 18.8249 33.859C18.8249 34.4381 18.3121 34.9116 17.6893 34.9116ZM15.6882 37.9427C15.2715 37.9427 15.0196 37.7103 15.0196 37.3213V36.9831L16.311 35.9432C16.5124 35.7783 16.7139 35.698 16.9292 35.698C17.1489 35.698 17.3779 35.7825 17.5794 35.9474L18.4449 36.6703L20.6108 34.8947C20.8306 34.713 21.0779 34.6284 21.3344 34.6284C21.5816 34.6284 21.8427 34.7172 22.0533 34.9032L24.0452 36.6027V37.3256C24.0452 37.7103 23.7842 37.9427 23.3813 37.9427H15.6882Z",
    fill: "#908CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9304 14.834H14.6513C13.7523 14.834 13.0234 15.4973 13.0234 16.3155C13.0234 17.1337 13.7523 17.7969 14.6513 17.7969H30.9304C31.8295 17.7969 32.5583 17.1337 32.5583 16.3155C32.5583 15.4973 31.8295 14.834 30.9304 14.834Z",
    fill: "#908CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2793 20.7598H14.6513C13.7523 20.7598 13.0234 21.423 13.0234 22.2412C13.0234 23.0594 13.7523 23.7227 14.6513 23.7227H86.2793C87.1783 23.7227 87.9072 23.0594 87.9072 22.2412C87.9072 21.423 87.1783 20.7598 86.2793 20.7598Z",
    fill: "#908CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4187 46.6855H6.51172V73.3522H94.4187V46.6855Z",
    fill: "#625E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9304 55.5742H14.6513C13.7523 55.5742 13.0234 56.2375 13.0234 57.0557C13.0234 57.8739 13.7523 58.5372 14.6513 58.5372H30.9304C31.8295 58.5372 32.5583 57.8739 32.5583 57.0557C32.5583 56.2375 31.8295 55.5742 30.9304 55.5742Z",
    fill: "#908CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2793 61.5H14.6513C13.7523 61.5 13.0234 62.1633 13.0234 62.9815C13.0234 63.7997 13.7523 64.463 14.6513 64.463H86.2793C87.1783 64.463 87.9072 63.7997 87.9072 62.9815C87.9072 62.1633 87.1783 61.5 86.2793 61.5Z",
    fill: "#908CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.489 5.94531H97.6748V74.0935H133.489V5.94531Z",
    fill: "#908CA0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5154_54779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 80,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegFullPageR);
export default __webpack_public_path__ + "static/media/icon-reg-full-page-R.29a83b76603eb6be4f6b2f166f2834ea.svg";
export { ForwardRef as ReactComponent };